import React from "react";
import SalaryAccrualsGenericSkeleton from "./SalaryAccrualsGenericSkeleton";

function SalaryAccrualsDetailSkeleton() {
  return (
    <>
      <SalaryAccrualsGenericSkeleton />
    </>
  );
}

export default SalaryAccrualsDetailSkeleton;
